module.exports = __webpack_public_path__ + "img/divider2-1080x62.655d9080.jpg";